import * as React from 'react';

import { useGlobalModalStore } from '@doltech/ui/lib/hocs/withGlobalModal';
import {
  ModalListeningSectionGuideContent,
  ModalListeningSectionGuideContentProps,
} from '@doltech/domains/ielts-test/ui/components/ModalListeningSectionGuide/ModalListeningSectionGuideContent';
import {
  ModalListeningTimeUpContent,
  ModalListeningTimeUpContentProps,
} from '@doltech/domains/ielts-test/ui/components/ModalListeningTimeUp/ModalListeningTimeUpContent';
import {
  ModalGeneralContent,
  ModalGeneralContentProps,
} from '../components/ModalGeneralContent/ModalGeneralContent';

export const useListeningFullTestModal = () => {
  const { show, hide, visible: modalOpen } = useGlobalModalStore();

  const openModalListeningSectionGuide = ({
    onStart,
  }: {
    testData?: {
      reviewTime?: number;
      totalSections?: number;
    };
    onStart?: () => void;
  }) => {
    show({
      content: (contentProps: ModalListeningSectionGuideContentProps) => (
        <ModalListeningSectionGuideContent {...contentProps} />
      ),
      title: null,
      closable: false,
      maskClosable: false,
      width: 520,
      centered: true,
      modalStyle: 'unstyled-full-height',
      contentProps: {
        onStart: () => {
          onStart?.();
          hide();
        },
      } as ModalListeningSectionGuideContentProps,
    });
  };

  const openModalListeningTimeUp = ({ onNextSection }: { onNextSection?: () => void }) => {
    show({
      content: (contentProps: ModalListeningTimeUpContentProps) => (
        <ModalListeningTimeUpContent {...contentProps} />
      ),
      title: null,
      closable: false,
      maskClosable: false,
      width: 430,
      centered: true,
      modalStyle: 'unstyled-full-height',
      contentProps: {
        nextSectionIndex: 1,
        lastSection: false,
        onOk: () => {
          onNextSection?.();
          hide();
        },
      } as ModalListeningTimeUpContentProps,
    });
  };

  const openModalConfirmSubmit = ({
    title,
    description,
    primaryButton,
    secondaryButton,
  }: ModalGeneralContentProps) => {
    show({
      content: (contentProps) => <ModalGeneralContent {...contentProps} />,
      title: null,
      closable: false,
      maskClosable: false,
      width: 480,
      modalStyle: 'unstyled-full-height',
      style: { padding: '0 16px' },
      contentProps: {
        title,
        description,
        primaryButton,
        secondaryButton,
      },
    });
  };

  return {
    openModalListeningSectionGuide,
    openModalListeningTimeUp,
    openModalConfirmSubmit,
    hide,
    modalOpen,
  };
};
